import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

/** Um texto de plataforma da IA: as regras internas ou um prompt padrão. */
export interface AiSystemPrompt {
  key: string;
  label: string;
  content: string;
  /** Texto de fábrica — o que o botão "restaurar padrão" devolve. */
  default_content: string;
  active: boolean;
  is_customized: boolean;
  /** true para as regras internas: desativá-las roda a IA sem piso de comportamento. */
  is_rules: boolean;
}

/** Padrões que o cliente restaura nos campos de prompt. */
export interface AiPromptDefaults {
  agent_base: string;
  manual_list: string;
  /** Prompt base da categoria do evento consultado; null quando não há. */
  event: string | null;
}

export type ImprovePromptContext = 'agent_base' | 'event' | 'manual_list';

export interface ImprovedPrompt {
  prompt: string;
  tokens_debited: number;
}

@Injectable({ providedIn: 'root' })
export class AiSystemPromptService {

  constructor(private http: HttpClient) { }

  // ---- admin ----

  list(): Observable<AiSystemPrompt[]> {
    return this.http.get<AiSystemPrompt[]>(`${environment.apiUrl}/ai-system-prompts`);
  }

  save(key: string, data: { content: string; active?: boolean }): Observable<any> {
    return this.http.put<any>(`${environment.apiUrl}/ai-system-prompts/${key}`, data);
  }

  // ---- cliente ----

  /** Padrões de fábrica. `platformEventId` traz também o prompt daquele evento. */
  defaults(platformEventId?: number | string | null): Observable<AiPromptDefaults> {
    const query = platformEventId ? `?platform_event_id=${platformEventId}` : '';
    return this.http.get<AiPromptDefaults>(`${environment.apiUrl}/ai-prompts/defaults${query}`);
  }

  /** Reescreve o prompt com o LLM. Cobra ai_tokens: é uma chamada real ao provedor. */
  improve(agentId: string, context: ImprovePromptContext, prompt: string): Observable<ImprovedPrompt> {
    return this.http.post<ImprovedPrompt>(`${environment.apiUrl}/ai-prompts/improve`, {
      ai_agent_id: agentId,
      context,
      prompt,
    });
  }
}
